export enum ServiceEnum {
  TV = 'TV',
  INTERNET = 'INTERNET',
  PHONELINE = 'PHONELINE',
  _2G = '_2G',
  _3G = '_3G',
  _4G = '_4G',
}
